<template>
  <div class="main-chapter1">
    <div class="right-info">
      СН РК 1.03-00-2011<br>
      Приложение В<br>
      (обязательное)
    </div>
    <div class="chapter-title">Общие сведения</div>
    <n-items>
      <n-button v-if="checkSign('executor')" @click="$var('exec', true)">Подписать</n-button>
      <n-input title="Наименование генерального подрядчика либо застройщика" v-bind="$form.input('executor')" />
      <n-input title="Наименование объекта строительства" v-bind="$form.input('title')" />
      <n-input title="Место нахождения объекта строительства" v-bind="$form.input('address')" />
      <!--   дата* номер, наименование уведомляемого органа   -->
      <n-input title="Уведомление о начале строительно-монтажных работ" v-bind="$form.input('notifyStart')" />
      <!--      Должность, фамилия, инициалы и подпись -->
      <n-input title="Лицо ответственное за строительство объекта и ведение журнала производства, работ" v-bind="$form.input('responsible')" />
      <!--      фамилия, инициалы и подпись главного инженера проекта-->
      <n-input title="Генеральная проектная организация" v-bind="$form.input('genProjector')" />
      <!--      должность, фамилия, инициалы и подпись руководителя-->
      <n-input title="Заказчик, застройщик" v-bind="$form.input('customer')" />
      <!--      должность, фамилия, инициалы и подпись руководителя (представителя)-->
      <n-input title="Технический надзор" v-bind="$form.input('tech')" />
      <div>Начало работ</div><br />
      <n-datepicker title="по плану (договору)" v-bind="$form.input('startedAtPlan')" inline />
      <n-datepicker title="фактически" v-bind="$form.input('startedAtFact')" inline /><br />
      <div>Окончание работ (ввод в эксплуатацию)</div><br />
      <n-datepicker title="по плану (договору)" v-bind="$form.input('endedAtPlan')" inline />
      <n-datepicker title="фактически" v-bind="$form.input('endedAtFact')" inline />
      <n-select :data="dataResponsible" title="Должность, фамилия, инициалы и подпись руководителя организации, выдавшего журнал"
                v-bind="$form.input('executorUser', 'select')" :disabled="!!journal.data.executorUser.name || !editable" />
      <c-journal-sign :sign="getSign(journal, 'executor')" />
      <n-datepicker title="Дата выдачи журнала, печать организации" v-bind="$form.input('giveAt')" />
      <!--   мощность, производительность, полезная площадь, вместимость и т.п. и сметная стоимость   -->
      <n-input title="Основные показатели объекта строительства" v-bind="$form.input('mainObjChar')" />
      <!--      дата и номер постановления (решения, приказа)-->
      <n-input title="Наименование органа, утвердившего проектную документацию" v-bind="$form.input('projectorOrgan')" />

      <span>Субподрядные организации и выполняемые ими работы</span>
      <n-table :columns="columns" :data="executors" />
      <span>Субподрядные проектные организации, выполнившие разделы (части) проекта </span>
      <n-table :columns="columns" />
      <span>Отметки об изменениях в записях в данном разделе</span>
      <n-table :columns="columnsRecords" />
      <n-button v-if="editable" color="success" @click="submit">Сохранить</n-button>
    </n-items>
    <c-modal-journal-do-sign v-if="$var('exec')" @close="$var('exec', false)" @submit="(s) => doSign('executor', s)" />
    <n-loader :loading="$var('load')" />
  </div>
</template>

<script>
import CModalJournalDoSign from '../../../components/journal/ModalDoSign'
import CJournalSign from '../../../components/journal/Sign'

export default {
  name: 'MainChapter1',
  components: { CModalJournalDoSign, CJournalSign, },
  props: {
    project: { type: Object, default: () => ({}), },
    journal: { type: Object, default: () => ({}), },
    editable: { type: Boolean, default: false, },
  },
  data: () => ({
    dataResponsible: [],
    subcontractors: [
      { name: '', bin: '', works: '', },
    ],
    columns: [
      { name: 'name', title: 'Наименование', },
      { name: 'bin', title: 'БИН', },
      { name: 'works', title: 'Работы', },
    ],
    columnsRecords: [
      { name: 'date', title: 'Дата', },
      { name: 'record', title: 'Пояснение', },
    ],
    executors: [],
  }),
  created() {
    this.$form.init(this.journal.data)
    this.loadExec()
  },
  methods: {
    checkSign(name) {
      if (name === 'executor') {
        return this.journal.data.executorUser.name === $app.auth.user().id && this.getSign(this.journal, 'executor').isApproved !== true
      }
    },
    getSign(item, name) {
      return $n.find(item.signs, [ 'name', name, ])
    },
    doSign(name, sign) {
      this.$var('load', true)
      $api.journals.main.doSign(this.journal.id, { name, sign, }).then((result) => {
        this.load()
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadExec() {
      $api.data.get(this.project.id, 'participants,executor,gen,all').then((response) => {
        this.dataResponsible = response.data.content
      })
    },
    submit() {
      this.$var('load', true)
      $api.journals.edit(this.project.id, 'main', this.$form.get()).then(() => {
        this.$emit('reload')
      }).finally(() => {
        this.$var('load', false)
      })
    },
    loadExecutors() {
      this.$var('load', true)
      $api.journals.main.companies.executors(this.project.id).then((response) => {
        this.executors = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
  
  }
</style>
